import { AtIcon } from '@curran-catalog/curran-atomic-library'
import classNames from 'classnames'

interface SelectProps {
  className?: string
  label?: string
  name: string
  options: SelectOption[]
  onChange: (value: string) => void
  value: string | number | null
  small?: boolean
  hideLabel?: boolean
  required?: boolean
  helperMessage?: string
}

export type SelectOption = {
  value: string | number | null | undefined
  label: string
  disabled?: boolean
}

// TODO: Move to atomic library

export const Select = ({
  className,
  onChange,
  label,
  name,
  value,
  options,
  small,
  hideLabel,
  required,
  helperMessage,
}: SelectProps) => {
  return (
    <div className={classNames(className, 'relative flex flex-col gap-1')}>
      {label && (
        <label
          htmlFor={name + '-select'}
          className={classNames(hideLabel ? 'sr-only' : 'text-sm leading-4 tw-flex tw-flex-row tw-gap-2')}
        >
          {label}
          {required && <AtIcon type="asterisk" size={8} color="error" className="tw-ml-1" />}
        </label>
      )}

      <select
        id={name + '-select'}
        name={name}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        className={classNames(
          small ? 'py-1.5' : 'py-3',
          'form-select relative w-full h-full cursor-default border leading-6 border-outlined-gray bg-white px-4 text-left focus:ring-0 focus:outline-none focus-visible:border-primary',
        )}
        required={required}
      >
        <option value="" disabled>
          Select...
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value ?? ''} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {helperMessage && <span className="tw-text-secondary tw-text-sm tw-leading-4">{helperMessage}</span>}
    </div>
  )
}
